import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';


import Stack from '@mui/joy/Stack';

import SupportMeContent from 'components/SupportMeContent';



const SupportHome = observer(() => {

    useEffect(() => {
        document.title = 'Support';
    }, []);
    return (
        <Stack m={1}>
            <SupportMeContent />
        </Stack>
    );

});



export default SupportHome;
